import { render, staticRenderFns } from "./whiteboard.vue?vue&type=template&id=5f3c9044"
import script from "./whiteboard.vue?vue&type=script&setup=true&lang=js"
export * from "./whiteboard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./whiteboard.vue?vue&type=style&index=0&id=5f3c9044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports